/**
 * Single source of truth for the human-readable app version.
 *
 * Bump this ONE constant on release — every UI surface (main taskbar,
 * Admin panel, Gym Notebook, marketing landing hero pill, feature-card
 * "New in v…" badges) reads from here.
 *
 * The service-worker cache buster (`public/sw.js` CACHE), build-id
 * (`build-id.ts`), and PWA `<meta name="app-version">` in `public/index.html`
 * are still separate — they use finer-grained slugs for cache-poison
 * protection and don't need to match the public version number exactly.
 */
export const APP_VERSION = '6.57';
